import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import './PhoneDropdown.css';

const PhoneDropdown = ({ phoneNumber = "+36 30 123 4567" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [buttonPosition, setButtonPosition] = useState({ top: 0, left: 0, width: 0 });
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  // Update button position when opening dropdown
  useEffect(() => {
    if (isOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setButtonPosition({
        top: rect.bottom + window.scrollY + 8,
        left: rect.left + window.scrollX,
        width: rect.width
      });
    }
  }, [isOpen]);

  // Close dropdown when clicking outside (support both mouse and touch)
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) && 
          buttonRef.current && !buttonRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    if (isOpen) {
      // Support both mouse and touch events for better mobile compatibility
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [isOpen]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // const handlePhoneClick = (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();
    
  //   // Clean the phone number for tel: protocol
  //   const cleanNumber = phoneNumber.replace(/[\s\-()]/g, '');
  //   const telLink = `tel:${cleanNumber}`;
    
  //   // Close dropdown first
  //   setIsOpen(false);
    
  //   // Direct dial - this is the most reliable method for mobile
  //   window.location.href = telLink;
  // };

  return (
    <div className="phone-dropdown-container" ref={dropdownRef}>
      <button 
        ref={buttonRef}
        className="order-button"
        onClick={toggleDropdown}
        type="button"
      >
        <span>Rendelj most</span>
        <span className={`arrow ${isOpen ? 'open' : ''}`}>▼</span>
      </button>
      
      {isOpen && createPortal(
        <div 
          className="phone-dropdown"
          style={{
            position: 'absolute',
            top: buttonPosition.top,
            left: buttonPosition.left,
            width: buttonPosition.width,
            zIndex: 9999
          }}
        >
          <a 
            href={`tel:${phoneNumber.replace(/[\s\-()]/g, '')}`}
            className="phone-item"
            style={{ 
              textDecoration: 'none', 
              color: 'inherit',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '12px 16px',
              width: '100%',
              boxSizing: 'border-box',
              cursor: 'pointer',
              touchAction: 'manipulation'
            }}
            onClick={() => setIsOpen(false)}
          >
            <span className="phone-icon">📞</span>
            <span className="phone-number">{phoneNumber}</span>
          </a>
        </div>,
        document.body
      )}
    </div>
  );
};

export default PhoneDropdown;